export default "__VITE_ASSET__XJbdt9yQ__"